
export const API_ENDPOINTS = {
    ENVIRONMENT: {
      FETCH: '/environment/fetch',
      SEARCH: '/environment/search',
      GET: '/environment/get',
      DELETE: '/environment/delete',
      CREATE: '/environment/create',
      UPDATE: '/environment/update'
    },
    ZONE: {
      FETCH: '/zone/fetch',
      SEARCH: '/zone/search',
      GET: '/zone/get',
      DELETE: '/zone/delete',
      CREATE: '/zone/create',
      UPDATE: '/zone/update',
      CREATEZONEMAP:'/zone/mappingcreate',
      UPDATEZONEMAP: '/zone/mappingupdate',
      FETCHZONEMAP: '/zone/mappingfetch',
      FINISHZONEMAP: '/zone/mappingfinish',
      GETSECURITYZONETYPES:'/zone/getsecurityzonetypes',
      FETCHZONEASSETS:'/zone/fetchzoneassets',
      GETZONEASSETSBYZONEID:'/zone/getzoneassetsbyzoneid',
      GETPLATFORMSBYSECURITYZONETYPE:'/zone/getplatformsbysecurityzonetype'
    },
    SECUREZONEASSET:{
      FETCH: '/secure-zone/assets/fetch',
      SEARCH: '/secure-zone/assets/search',
      GETASSETPARAMETERS: '/secure-zone/assets/assettypeparameters'
    },
    PLATFORM: {
      FETCH: '/platform/fetch',
      SEARCH: '/platform/search',
      GET: '/platform/get',
      DELETE: '/platform/delete',
      CREATE: '/platform/create',
      UPDATE: '/platform/update'
    },
    DASHBOARD: {
      FETCH: "/secure-zone/dashboard/summary"
    }
};